import React from 'react';
import ChevronUp from '../assets/images/chevron-up.svg';

export default () => {
  return (
    <div>
      <img src={ChevronUp} alt="collapse-row-icon" />
    </div>
  );
};
